import { MembershipValidityPeriod, QuestionType } from "@simplyk/common";

import { QuestionOutput, RateOutput } from "@/common/types/trpc";

type MembershipRenewalFields = Pick<RateOutput, "allowAutomaticRenewal" | "membershipValidityPeriod">;

export const isAutoRenewableMembershipRate = (rate: MembershipRenewalFields): boolean => {
  if (!rate.membershipValidityPeriod) {
    return false;
  }
  return (
    rate.membershipValidityPeriod === MembershipValidityPeriod.OneMonthAfterPayment ||
    Boolean(rate.allowAutomaticRenewal)
  );
};

export const allowsMultipleMembershipsPerPurchase = (rates: MembershipRenewalFields[]): boolean =>
  rates.every((rate) => !isAutoRenewableMembershipRate(rate));

type MembershipSelectionRate = MembershipRenewalFields & { id: string; groupMembershipMaxMembers?: number | null };

export const allowsMultipleMembershipsForSelection = (
  rates: MembershipSelectionRate[],
  candidate: MembershipSelectionRate,
  selectedRateIds: ReadonlySet<string>
): boolean => {
  if (!rates.some((rate) => rate.groupMembershipMaxMembers)) {
    return allowsMultipleMembershipsPerPurchase(rates);
  }
  return (
    !isAutoRenewableMembershipRate(candidate) &&
    rates.every((rate) => !selectedRateIds.has(rate.id) || !isAutoRenewableMembershipRate(rate))
  );
};

export const isMemberIdentityQuestion = (question: Pick<QuestionOutput, "type">): boolean =>
  question.type === QuestionType.Name || question.type === QuestionType.Email;
